import { useParams, useRouteContext } from '@tanstack/react-router';
import { ReactNode } from 'react';

import { UserRole } from '@/types';

interface WithAuthorizationProps {
  /** Required role(s) to access the content */
  authorizedRoles: UserRole | UserRole[];
  /** Custom fallback content when user is not authorized */
  fallback?: ReactNode;
  /** Custom loading content while authorization is being determined */
  loading?: ReactNode;
  /** Children to render when authorized */
  children: ReactNode;
}

export function WithAuthorization({
  authorizedRoles,
  fallback = null,
  loading = null,
  children,
}: WithAuthorizationProps) {
  const { auth } = useRouteContext({
    from: '/_authenticated',
  });

  const { tenantId } = useParams({
    from: '/_authenticated/$tenantId',
  });

  if (auth.isLoading) {
    return loading ? <>{loading}</> : null;
  }

  const isAuthorized = auth.hasRole(authorizedRoles, tenantId);

  if (!isAuthorized) {
    return fallback ? <>{fallback}</> : null;
  }

  return <>{children}</>;
}
